import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { CEPSetupFieldEnum as Fields } from 'Common/FieldEnum';
import ReactTable from 'Common/ReactTableWrapper';
import { InputField } from 'Common/SemanticWrapper';
import { InputMode } from 'Common/FormEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { CEP_SETUP_FORM_NAME } from 'Common/FormEnum';

class CEPSetupTableContainer extends Component {
  static propTypes = {
    loading: PropTypes.bool,
  };

  renderPercentField = row => {
    return (
      <Field
        label={false}
        component={InputField}
        name={`${Fields.Sites}[${row.index}].Percentage`}
        compact
        className={'shorter'}
        numericSize={[5, 2]}
        mode={InputMode.Decimal}
      />
    );
  };

  columns = [
    {
      Header: 'Site ID',
      accessor: 'SiteId',
      filterable: true,
    },
    {
      Header: 'Site Name',
      accessor: 'Description',
      filterable: true,
    },
    {
      Header: 'Identified Students (%)',
      accessor: 'Percentage',
      Cell: this.renderPercentField,
      sortable: false,
    },
    {
      Header: 'Multiplier',
      accessor: 'Multiplier',
      filterable: true,
    },
  ];

  render() {
    return (
      <ReactTable
        saveState={{ tableName: TableNamesEnum.CEP_SETUP_TABLE }}
        loading={this.props.sitesLoading}
        data={this.props.data ? this.props.data : []}
        resizable={false}
        columns={this.columns}
        defaultPageSize={10}
      />
    );
  }
}

export const CEPSetupTable = reduxForm({
  form: CEP_SETUP_FORM_NAME,
  enableReinitialize: true,
})(withRouter(connect()(CEPSetupTableContainer)));



// WEBPACK FOOTER //
// ./src/pages/cepsetup/components/CEPSetupTable.js